import circleIcon from "@/assets/leaflet/circleIcon";
import L from "leaflet";
import { FC } from "react";
import { Marker } from "react-leaflet";

interface IUserPoint {
  user: UserWithColor;
}

const UserPoint: FC<IUserPoint> = ({ user }) => {
  const lastTracePoint =
    user.traces.length > 0
      ? user.traces[user.traces.length - 1].points.length > 0
        ? user.traces[user.traces.length - 1].points[user.traces[user.traces.length - 1].points.length - 1]
        : null
      : null;

  if (!user.coordinates || user.coordinates.id === lastTracePoint?.id) {
    return null;
  }

  const formattedTraceHeadIcon = new L.Icon({
    iconUrl: circleIcon(user?.color ?? "black"),
    iconSize: [22, 22],
  });

  return <Marker position={[user.coordinates.x, user.coordinates.y]} icon={formattedTraceHeadIcon} />;
};

export default UserPoint;
